export var PackageDimensionsAndWeight = function PackageDimensionsAndWeight(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return packageDimensionsAndWeightBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return packageDimensionsAndWeightBuilder(strictLocalize).getDescription();
    }
  };
};
var packageDimensionsAndWeightBuilder = function packageDimensionsAndWeightBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "kVBhvj",
        defaultMessage: [{
          "type": 0,
          "value": "Restrictions applicables aux colis expédiés avec Faire"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "yAuVAD",
        defaultMessage: [{
          "type": 0,
          "value": "Lorsque vous utilisez l'option Expédier avec Faire, vous devez respecter les restrictions de poids et de dimensions du colis imposées par le transporteur. Lisez les articles du Centre d'aide que nous avons répertoriés pour connaître les différentes possibilités ou contactez-nous pour obtenir de l'aide. Vous pouvez aussi essayer de passer par un autre transporteur ou choisir d'expédier par vous-même."
        }]
      })];
    }
  };
};